// Auto-class headings, links, and images in article content
document.addEventListener('DOMContentLoaded', () => {
  if (window.__fbAutoClassInit) return;
  window.__fbAutoClassInit = true;

  // Scope: article body
  const root =
    document.querySelector('.article .article__content') ||
    document.querySelector('.article__content');
  if (!root) return;

  // Don’t touch things inside hero/ToC/author/FAQ
  const EXCLUDE =
    ':not(.free-bleed-hero-section *):not(.free-bleed-toc-card *):not(.free-bleed-author-card *):not(.free-bleed-faq-section *)';

  // 1) Headings
  root.querySelectorAll(`h2${EXCLUDE}, h3${EXCLUDE}, h4${EXCLUDE}`).forEach(h => {
    if (h.matches('h2')) h.classList.add('free-bleed-h2');
    if (h.matches('h3')) h.classList.add('free-bleed-h3');
    if (h.matches('h4')) h.classList.add('free-bleed-h4');
  });

  // 2) Links
  root.querySelectorAll(`a${EXCLUDE}`).forEach(a => {
    a.classList.add('free-bleed-link');

    const href = a.getAttribute('href') || '';
    const isExternal = /^https?:\/\//i.test(href) && !href.includes(location.host);
    if (isExternal) {
      a.setAttribute('target', '_blank');
      // keep any existing rel values, but ensure noopener/noreferrer are present
      const existingRel = (a.getAttribute('rel') || '').toLowerCase().split(/\s+/);
      ['noopener', 'noreferrer'].forEach(val => {
        if (!existingRel.includes(val)) existingRel.push(val);
      });
      a.setAttribute('rel', existingRel.filter(Boolean).join(' '));
    }
  });

  // 3) Images (skip hero, author cards, faq, toc)
  root.querySelectorAll(`img${EXCLUDE}`).forEach(img => {
    // Don’t touch images that already have a more specific FB class
    if (!img.classList.contains('free-bleed-content-image')) {
      img.classList.add('free-bleed-content-image');
    }
  });
});


// Scroll Controls
// Free Bleed: Floating scroll buttons (prev/next H2/H3)
// - Excludes ToC, author cards, and headings from FAQ onward
// - Smooth scroll with header offset
document.addEventListener('DOMContentLoaded', () => {
  if (window.__fbScrollInit) return;
  window.__fbScrollInit = true;

  const controls = document.querySelector('.free-bleed-scroll-controls');
  if (!controls) return;

  const upBtn = controls.querySelector('.fb-scroll-up');
  const downBtn = controls.querySelector('.fb-scroll-down');

  // Where we look for headings
  const content =
    document.querySelector('.article .article__content') ||
    document.querySelector('.article__content') ||
    document;

  // Gather H2/H3 and apply same exclusions as ToC
  let headings = Array.from(content.querySelectorAll('h2, h3')).filter(
    (h) =>
      !h.closest('.free-bleed-toc-card') &&
      !h.closest('.free-bleed-author-card') &&
      !h.matches('[data-toc-exclude], .no-toc')
  );

  // Cut off everything from first FAQ onward
  const isFaq = (el) => {
    const t = (el.textContent || '').trim().toLowerCase();
    return t.includes('faq') || t.includes('frequently asked questions');
  };
  const cutoff = headings.findIndex(isFaq);
  if (cutoff >= 0) headings = headings.slice(0, cutoff);

  if (!headings.length) {
    // Nothing to jump between — hide controls
    controls.classList.add('is-hidden');
    return;
  }

  // Ensure IDs exist
  const used = new Set();
  const slugify = (txt) => {
    const base = (txt || 'section')
      .trim().toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-') || 'section';
    let s = base, i = 2;
    while (used.has(s) || document.getElementById(s)) s = `${base}-${i++}`;
    used.add(s);
    return s;
  };
  headings.forEach((h, i) => { if (!h.id) h.id = slugify(h.textContent || `section-${i}`); });

  // Scroll helpers
  const OFFSET = 80; // match your ToC/header height
  const getY = () => window.pageYOffset || document.documentElement.scrollTop || 0;
  const scrollToY = (y) => {
    const prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: y, behavior: prefersReduce ? 'auto' : 'smooth' });
  };

  const nextIndex = () => {
    const y = getY() + OFFSET + 2;
    for (let i = 0; i < headings.length; i++) {
      const top = headings[i].getBoundingClientRect().top + getY() - OFFSET;
      if (top > y + 1) return i;
    }
    return -1;
  };
  const prevIndex = () => {
    const y = getY() - 2;
    for (let i = headings.length - 1; i >= 0; i--) {
      const top = headings[i].getBoundingClientRect().top + getY() - OFFSET;
      if (top < y) return i;
    }
    return -1;
  };

  // Click handlers
  downBtn?.addEventListener('click', () => {
    const i = nextIndex();
    if (i === -1) {
      // no next section — go to bottom
      scrollToY(document.body.scrollHeight);
    } else {
      const top = headings[i].getBoundingClientRect().top + getY() - OFFSET;
      scrollToY(top);
    }
  });

  upBtn?.addEventListener('click', () => {
    const i = prevIndex();
    if (i === -1) {
      // no previous section — go to top
      scrollToY(0);
    } else {
      const top = headings[i].getBoundingClientRect().top + getY() - OFFSET;
      scrollToY(top);
    }
  });

  // Enable/disable buttons + hide controls if page is short
  const refresh = () => {
    const y = getY();
    const max = Math.max(0, document.body.scrollHeight - window.innerHeight);

    if (max < 400) {
      controls.classList.add('is-hidden');
      return;
    } else {
      controls.classList.remove('is-hidden');
    }

    if (y < 10) upBtn?.setAttribute('disabled', '');
    else upBtn?.removeAttribute('disabled');

    if (y > max - 10) downBtn?.setAttribute('disabled', '');
    else downBtn?.removeAttribute('disabled');
  };

  refresh();
  window.addEventListener('scroll', () => requestAnimationFrame(refresh));
  window.addEventListener('resize', () => requestAnimationFrame(refresh));
});


// Auto-fill author date + read time for any ".free-bleed-author-meta" on the page
document.addEventListener('DOMContentLoaded', () => {
  if (window.__fbMetaInit) return; // guard against double-init
  window.__fbMetaInit = true;

  const targets = document.querySelectorAll('.free-bleed-author-meta');
  if (!targets.length) return;

  // 1) Published date sources: theme meta <time>, then og:published_time, then any time[datetime]
  const metaTimeEl = document.querySelector('.article__meta time') || document.querySelector('time[datetime]');
  const ogTime =
    document.querySelector('meta[property="article:published_time"]')?.content ||
    document.querySelector('meta[name="date"]')?.content;

  let publishedText = '';
  if (metaTimeEl?.textContent?.trim()) {
    publishedText = metaTimeEl.textContent.trim();
  } else if (ogTime) {
    const d = new Date(ogTime);
    if (!isNaN(d)) {
      publishedText = d.toLocaleDateString(undefined, { year:'numeric', month:'long', day:'numeric' });
    }
  }

  // 2) Read time: compute from article body text (exclude non-content bits)
  const content = document.querySelector('.article__content') || document.querySelector('article') || document.body;
  let minutes = 0;
  if (content) {
    const clone = content.cloneNode(true);
    clone.querySelectorAll(
      '.free-bleed-author-card, .free-bleed-author-meta, .free-bleed-toc-card, .free-bleed-faq-section, .free-bleed-hero-section, script, style, noscript'
    ).forEach(el => el.remove());
    const text = (clone.textContent || '').replace(/\s+/g, ' ').trim();
    const words = (text.match(/\b[\w’\'-]+\b/g) || []).length;
    minutes = Math.max(1, Math.ceil(words / 200)); // ~200 wpm
  }

  // 3) Fill all targets
  targets.forEach(container => {
    const dateEl = container.querySelector('.author-date');
    const readEl = container.querySelector('.author-read-time');

    if (dateEl && publishedText) dateEl.textContent = publishedText;
    if (readEl && minutes) readEl.textContent = `${minutes} min read`;

    // add a separator dot if both exist
    if (dateEl?.textContent && readEl?.textContent && !container.querySelector('.meta-sep')) {
      const sep = document.createElement('span');
      sep.className = 'meta-sep';
      sep.textContent = '·';
      dateEl.after(sep);
    }
  });
});


// free-bleed.js — Accordion only

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".free-bleed-faq-item");

  if (!items.length) return;

  items.forEach((item, idx) => {
    const btn = item.querySelector(".free-bleed-faq-question");
    const answer = item.querySelector(".free-bleed-faq-answer");
    if (!btn || !answer) return;

    // Accessibility wiring (safe even if already set)
    const id = answer.id || `faq-answer-${idx}`;
    answer.id = id;
    btn.setAttribute("aria-controls", id);
    btn.setAttribute("aria-expanded", "false");
    answer.setAttribute("hidden", "");

    // Ensure closed state styles
    answer.style.maxHeight = "0px";

    btn.addEventListener("click", () => {
      const isOpen = btn.getAttribute("aria-expanded") === "true";

      // Close all others
      items.forEach((other) => {
        const ob = other.querySelector(".free-bleed-faq-question");
        const oa = other.querySelector(".free-bleed-faq-answer");
        if (!ob || !oa) return;
        ob.setAttribute("aria-expanded", "false");
        oa.classList.remove("open");
        oa.style.maxHeight = "0px";
        oa.setAttribute("hidden", "");
      });

      // Toggle current
      if (!isOpen) {
        btn.setAttribute("aria-expanded", "true");
        answer.classList.add("open");
        answer.removeAttribute("hidden");
        // Smooth expand to content height
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        btn.setAttribute("aria-expanded", "false");
        answer.classList.remove("open");
        answer.style.maxHeight = "0px";
        answer.setAttribute("hidden", "");
      }
    });
  });
});
